export default "__VITE_ASSET__CPRDx5Ux__"